<header>
  <app-navbar></app-navbar>
</header>
<main>
  <router-outlet></router-outlet>
</main>
